export enum CustomerMarkers {
  START = 'Start',
  START_END = 'Start end',
  WELCOME = 'Welcome',
  WELCOME_END = 'Welcome end',
  RELAX = 'Relax',
  RELAX_END = 'Relax end',
  BOOKMARK_KNOW = 'Bookmark Know',
  BOOKMARK_KNOW_END = 'Bookmark Know end',
  BOOST_YOUR_KNOWLEDGE = 'Boost Your Knowledge',
  BOOST_YOUR_KNOWLEDGE_END = 'Boost Your Knowledge end',
  COMMUNITY_PART_1 = 'Community Part 1',
  COMMUNITY_PART_1_END = 'Community Part 1 end',
  COMMUNITY_PART_2 = 'Community Part 2',
  COMMUNITY_PART_2_END = 'Community Part 2 end',
  EVENTS = 'Events',
  EVENTS_END = 'Events end',
  EDUCATION = 'Education',
  EDUCATION_END = 'Education end',
  CONTACT_US = 'Contact us',
  CONTACT_US_END = 'Contact us end',
  SUMMARY = 'Summary',
  SUMMARY_END = 'Summary end',
}

export enum EmployeerMarkers {
  START = 'Start',
  START_END = 'Start end',
  WELCOME = 'Welcome',
  WELCOME_END = 'Welcome end',
  RELAX = 'Relax',
  RELAX_END = 'Relax end',
  BOOKMARK_KNOW = 'Bookmark Know',
  BOOKMARK_KNOW_END = 'Bookmark Know end',
  COMMUNITY = 'Community',
  COMMUNITY_END = 'Community end',
  RESOURCES = 'Resources',
  RESOURCES_END = 'Resources end',
  BOOKMARK_ONE_GENESYS = 'Bookmark One Genesys',
  BOOKMARK_ONE_GENESYS_END = 'Bookmark One Genesys end',
  ELEARNING = 'Elearning',
  ELEARNING_END = 'Elearning end',
  SUMMARY = 'Summary',
  SUMMARY_END = 'Summary end',
}
